<script setup>
import { useSlots } from 'vue'

defineProps({
    listClass: {
        type: String,
        required: false,
        default: 'bg-white border border-gray-200 rounded-xl',
    },
})

const slots = useSlots()
</script>

<template>
    <div :class="listClass">
        <div
            v-if="slots.header"
            class="pl-4 pr-2 py-2 bg-gray-50 rounded-t-xl border-b border-gray-100 text-sm font-semibold text-gray-900"
        >
            <slot name="header" />
        </div>
        <div
            v-if="slots.status"
            class="py-6 text-center text-xs text-gray-500"
        >
            <slot name="noitems" />
        </div>
        <ul class="divide-y divide-gray-100">
            <slot />
        </ul>
        <div
            v-if="slots.footer"
            class="px-4 py-3 border-t border-gray-200 text-xs text-gray-500"
        >
            <slot name="footer" />
        </div>
    </div>
</template>
